import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import timeline from "highcharts/modules/timeline";

timeline(Highcharts);

function NtnEquipementStatesTimeLine(props) {
  let row = props.data.row;
  const options = {
    chart: {
      type: "timeline",
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    title: {
      text: "Etats du conteneur",
    },
    subtitle: {
      text: "liste des etats du conteneur",
    },
    height: 30,
    series: [
      {
        dataLabels: {
          connectorColor: "silver",
          alternate: false,
          connectorWidth: 5,
          distance: -50,
        },

        data: [
          {
            name: 'Entrée au port<span style="font-family: FontAwesome; color:#97BAEC"><img src="../../../assets/images/entreePort.JPG"/> </span>',
            label: row.portcall?.list[0]?.aTA.substring(0, 16),
            // description: "ce conteneur est entré au port le  ",
            color: "#97BAEC",
          },
          {
            name: "Entrée au terminale",
            label: row.gateInDateTime?.substring(0, 16),
            //description: "ce conteneur est entré au port le  ",
            color: "#6987D5",
          },

          {
            name: "Main levée",
            label: row.customsClearanceDateTime?.substring(0, 16),
            //description: "la date de la main levée  est  ",
            color: "#445BC1",
          },
          {
            name: "Chargement",
            label: row.loadedDateTime?.substring(0, 16),
            //description: "ce conteneur est chargé le ",
            color: "#1E35A9FF",
          },
          {
            name: "Départ navire",
            label: row.portcall?.list[0]?.aTD.substring(0, 16),
            //description: "ce conteneur est sortie du terminal le ",
            color: "#323f7a",
          },
        ],
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}

export default NtnEquipementStatesTimeLine;
